!(function (e) {
  function i(e) {
    if (e.hasClass("slick-initialized")) return;
    let i = e.find("img").length;
    e.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: i > 1,
      arrows: !0,
      infinite: !0,
      pauseOnHover: !1,
      pauseOnFocus: !1,
      fade: !0,
      speed: 640,
      cssEase: "linear",
      autoplay: !1,
      accessibility: !1,
      swipe: !0,
      touchThreshold: 15,
      swipeToSlide: !1,
      initialSlide: "map" === Cookies.get("filter-slider-view") ? 1 : 0,
    });
  }
  function a() {
    if (!("IntersectionObserver" in window)) {
      e(".tour-card__image").each(function () {
        console.log(e(".tour-card__image").length), i(e(this));
      });
      return;
    }
    let a = new IntersectionObserver(
      (a, s) => {
        a.forEach((a) => {
          if (a.isIntersecting) {
            let t = e(a.target);
            i(t), s.unobserve(a.target);
          }
        });
      },
      { rootMargin: "100px", threshold: 0.1 }
    );
    e(".tour-card__image").each(function () {
      a.observe(this);
    });
  }
  e(document).ready(function () {
    if ((e(".tooltip").not(".tooltipstered").tooltipster({ theme: "tooltipster-light", trigger: "click", maxWidth: "200" }), e("#edit-field-group-demograph-you-travel").length)) {
      var i = e("#number-adults"),
        a = e("#number-children");
      e("#edit-field-group-demograph-you-travel input[type=radio]").click(function () {
        switch (e(this).val()) {
          case "as a couple":
          case "with a friend":
            i.val(2), a.val(0);
            break;
          case "with a family":
            i.val(2), a.val(1);
            break;
          case "alone":
            i.val(1), a.val(0);
        }
      });
    }
  }),
    e(document).ready(function (e) {
      var $sidebar = e('.search-sidebar.hidden-mobile');
      if ($sidebar.length) {
        $sidebar.removeClass('hidden-mobile');
      }
    }),
    e(document).ready(function () {
      e(".nav-tabs a").click(function (i) {
        i.preventDefault(),
          e(".nav-tabs a").removeClass("collapse"),
          e(".nav-tabs--duplicated a").removeClass("collapse"),
          e(".tab-pane").removeClass("collapse"),
          e(this).addClass("collapse"),
          e(e(this).attr("href")).addClass("collapse"),
          e('.nav-tabs--duplicated a[href="' + e(this).attr("href") + '"]').addClass("collapse");
      }),
        e(".nav-tabs--duplicated a").click(function (i) {
          i.preventDefault(),
            e(".nav-tabs a").removeClass("collapse"),
            e(".nav-tabs--duplicated a").removeClass("collapse"),
            e(".tab-pane").removeClass("collapse"),
            e(this).addClass("collapse"),
            e(e(this).attr("href")).addClass("collapse"),
            e('.nav-tabs--duplicated a[href="' + e(this).attr("href") + '"]').addClass("collapse");
        });
    }),
    e(document).ready(function (e) {
      var value = Cookies.get("filter-slider-view"); // e.g. "map" or "list"
      if (value) {
        var el = document.querySelector(
          'input[name="filter-slider-view"][value="' + value + '"]'
        );
        if (el) {
          el.checked = true;
        }
      }
    }),
    e(document).ready(function (e) {
      var value = Cookies.get("filter-view"); // e.g. "list" or "grid"
      if (!value) value = "list";
      var el = document.querySelector(
        'input[name="filter-view"][value="' + value + '"]'
      );
      if (el) el.checked = true;
      document.querySelectorAll('input[name="filter-view"]').forEach(function(input) {
        input.addEventListener("change", function() {
          Cookies.set("filter-view", this.value, { expires: 30, path: "/" });
        });
      });
    }),
    e(document).ready(function (e) {
      var viewValue = Cookies.get("filter-view");
      if (!viewValue) viewValue = "list"; // default
      var $viewContent = e(".view-content.list-grid");
      if (viewValue === "grid") {
        $viewContent.removeClass("list-grid--list");
      } else {
        $viewContent.addClass("list-grid--list");
      }
      // Slick is initialized lazily via IntersectionObserver, so only refresh initialized sliders.
      e(".tour-card__image.slick-initialized").slick("refresh");
    }),
    e(document).ready(function (e) {
      e('input[name="filter-view"]').on("click", function () {
        if ("edit-grid" === e(this).attr("id")) {
          e(".view-content.list-grid").removeClass("list-grid--list");
        } else {
          e(".view-content.list-grid").addClass("list-grid--list");
        }

        // Refresh only initialized sliders to avoid calling methods on non-initialized elements.
        e(".tour-card__image.slick-initialized").slick("refresh");
      }),
        e(".tours-listing__more-link a").on({
          click: function (i) {
            var a = e(i.target);
            i.preventDefault(),
              a.hasClass("less")
                ? (a.parents("ul").first().find(".hidden-destinations").addClass("hidden"), a.removeClass("less"), a.text("More..."))
                : (a.parents("ul").first().find(".hidden-destinations").removeClass("hidden"), a.addClass("less"), a.text("Less"));
          },
        }),
        e(".tab-pane button").on("click", function () {
          e(window).width(),
            e(this)
              .parent()
              .find('div[data-bs-parent="#' + e(this).attr("id") + '"]')
              .hasClass("show")||
            typeof e(this).attr("id") === 'undefined'
              ? (e(this)
                .parent()
                .find('div[data-bs-parent="#' + e(this).attr("id") + '"]')
                .slideUp("slow")
                .removeClass("show"),
                e(this).addClass("collapsed"),
                e(this).attr("aria-expanded", "false"))
              : (e(this)
                .parent()
                .find('div[data-bs-parent="#' + e(this).attr("id") + '"]')
                .slideDown("slow")
                .addClass("show"),
                e(this).removeClass("collapsed"),
                e(this).attr("aria-expanded", "true"));
        }),
        e("ul.menu__list > .menu__item").on("click", function () {
          1024 >= e(window).width() &&
          (e(this).hasClass("show")
            ? (e(this).removeClass("show"), e(".menu__more-list").hasClass("show") || (e("body").removeClass("menu-open"), e("html").css({ overflow: "visible", height: "auto" })))
            : (e(this).parent().find(".menu__item.show").removeClass("show"), e(this).addClass("show"), e("body").addClass("menu-open"), e("html").css({ overflow: "hidden", height: "100%" })));
        }),
        e(".menu__more-link > span").on("click", function () {
          e(this).parent().hasClass("show") &&
          (e(".menu__more-list").hasClass("show")
            ? (e(".menu__more-list").removeClass("show"), e("body").removeClass("menu-open"), e("html").css({ overflow: "visible", height: "auto" }))
            : (e(".menu__more-list").addClass("show"), e(".menu__item").removeClass("show"), e("body").addClass("menu-open"), e("html").css({ overflow: "hidden", height: "100%" })));
        }),
        e(document).on("click", ".menu__list > .menu__item", function () {
          e(".menu__more-list").removeClass("show"), e(".menu__more-list > .menu__item").removeClass("show");
        });
    }),
    e(document).ready(function () {
      function i(i) {
        var a = e(i);
        if (!a.length) return !1;
        var s = a.width(),
          t = 0;
        return (
          a.children().each(function () {
            t += e(this).outerWidth(!0);
          }),
          t <= s
        );
      }
      function a(a, s) {
        var t = e(a),
          l = e(s);
        if (t.length && l.length)
          for (; !i(a) && t.children().length > 0; ) {
            var n = t.children("ul").find(".menu__item").last();
            l.append(n), l.length > 0 && l.parent().addClass("show");
          }
      }
      a("nav.menu", "nav.menu .menu__more-link .menu__more-list"),
        e(window).on("resize", function () {
          a("nav.menu", "nav.menu .menu__more-link .menu__more-list");
        });
    }),
    e(document).mouseup(function (i) {
      var a = e("aside.layout-sidebar-first").find(".search-sidebar"),
        s = a.find(".search-sidebar__container");
      !s.is(i.target) && 0 === s.has(i.target).length && a.hasClass("show") && a.removeClass("show");
    }),
    e(function () {
      var i, s;
      (i = Cookies.get("filter-slider-view") || "gallery"),
        e("body").on("change", 'input[name="filter-slider-view"]', function (a) {
          var s = e(a.target).val();
          if (s !== i) {
            var t = "map" === s ? 1 : 0,
              l = e('input[name="filter-slider-view"]'),
              n = e(".tour-card__image.slick-initialized");
            if (n.length) {
              l.prop("disabled", !0);
              var o = 0,
                r = 0,
                d = function () {
                  ++r === o && l.prop("disabled", !1);
                };
              n.each(function () {
                var i = e(this),
                  a = i.slick("getSlick");
                if (a) {
                  var l = a.currentSlide;
                  !0 !== a.options.arrows && i.slick("slickSetOption", "arrows", !0, !1);
                  var n = "map" !== s;
                  a.options.swipe !== n && i.slick("slickSetOption", "swipe", n, !1), l !== t && (o++, i.one("afterChange.viewToggle", d), i.slick("slickGoTo", t));
                }
              }),
              0 === o && l.prop("disabled", !1),
                Cookies.set("filter-slider-view", s),
                (i = s);
            }
          }
        }),
        e("#edit-list, #edit-grid").on({
          change: function (i) {
            var a = e(i.target);
            Cookies.set("filter-view", a.val());
          },
        }),
        a(),
        e("body").on("ajax-load-more-success", function (e, i) {
          "trip" === i.postType && a();
        }),
        (s = e(".landing-slider")).find(".landing-banner").length,
      s.length > 0 &&
      s.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !0,
        infinite: !0,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        fade: !0,
        speed: 640,
        cssEase: "linear",
        autoplay: !1,
        accessibility: !1,
        swipe: !0,
        touchThreshold: 15,
        swipeToSlide: !1,
        initialSlide: 0,
      })
    });
})(jQuery);
